import { ApiNamespaces, IQueuedRequest, OneAPIOptions } from '../../common'
import { AppPluginsApi } from './app'
import { BackofficePluginsApi } from './backoffice'
import { Queue } from '../../queue'

export class Plugins implements ApiNamespaces {
  app: AppPluginsApi
  backoffice: BackofficePluginsApi
  constructor(
    name: string,
    sessionId: string,
    requestsQueue: Queue<IQueuedRequest>,
    options?: OneAPIOptions
  ) {
    this.app = new AppPluginsApi(name, sessionId, requestsQueue, options)
    this.backoffice = new BackofficePluginsApi(
      name,
      sessionId,
      requestsQueue,
      options
    )
  }

  invalidateAll() {
    this.app.invalidateAll()
    this.backoffice.invalidateAll()
  }
}
